import { useSyncExternalStore } from 'react';
import {
  getFruitNinjaRemoteUiSnapshot,
  subscribeFruitNinjaRemoteUi,
} from '../../state/fruitNinjaRemoteUiStore.ts';
import { FRUIT_NINJA_REMOTE_DOM } from './fruitNinjaRemoteDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function FruitNinjaRemotePause() {
  const d = FRUIT_NINJA_REMOTE_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeFruitNinjaRemoteUi,
    getFruitNinjaRemoteUiSnapshot,
    getFruitNinjaRemoteUiSnapshot,
  );

  const pauseBody =
    s.split && s.player1Score !== null && s.player2Score !== null
      ? `P1 ${s.player1Score} : ${s.player2Score} P2`
      : String(s.pauseScore);

  return (
    <div
      id={d.pauseRoot}
      className="fruit-remote-pause"
      hidden={!s.pauseVisible}
      role="dialog"
      aria-modal="true"
      aria-labelledby={d.pauseTitle}
    >
      <div className="fruit-remote-pause__panel">
        <h2 id={d.pauseTitle} className="fruit-remote-pause__title">
          {t('game.pause')}
        </h2>
        <div className="fruit-remote-pause__score">{pauseBody}</div>
      </div>
    </div>
  );
}
